module.exports = __webpack_public_path__ + "images/3dfcf6946ea7885cfaa3fdee3df65f71-level1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/level1.png
// module id = 1024
// module chunks = 0